var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUseCase = function SvgIconUseCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M15.375 12.5v1.875A2.63 2.63 0 0 1 12.75 17h-7.5a2.63 2.63 0 0 1-2.625-2.625v-.488c0-1.177.96-2.137 2.138-2.137h9.862c.412 0 .75.338.75.75M11.625 2h-5.25c-3 0-3.75.75-3.75 3.75v5.685c.57-.503 1.32-.81 2.138-.81h9.862c.412 0 .75-.338.75-.75V5.75c0-3-.75-3.75-3.75-3.75M9.75 8.563H6A.567.567 0 0 1 5.438 8c0-.308.255-.562.562-.562h3.75c.307 0 .563.255.563.562a.567.567 0 0 1-.563.563M12 5.937H6a.567.567 0 0 1-.562-.562c0-.308.255-.562.562-.562h6c.307 0 .563.255.563.562a.567.567 0 0 1-.563.563"
  })));
};
export default SvgIconUseCase;